import { useState, useEffect } from "react";

export default function LoginPage() {
  const [email, setEmail]       = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr]           = useState("");
  const [busy, setBusy]         = useState(false);
  const [branding, setBranding] = useState<{ name: string; logoUrl: string | null } | null>(null);

  useEffect(() => {
    fetch("/api/v1/public/tenant-branding")
      .then((r) => r.json())
      .then((d) => setBranding(d))
      .catch(() => {});
  }, []);

  /** Kegagalan login TIDAK boleh disamarkan jadi satu pesan generik: penyebabnya
   *  bisa kredensial salah (401 dari API), API mati (proxy 502/504), atau DB mati
   *  (500). Ketiganya butuh tindakan berbeda, jadi ketiganya dibedakan di sini. */
  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      const r = await fetch("/api/v1/auth/login", {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      if (r.ok) { location.href = "/a/dashboard"; return; }
      const raw = await r.text();
      let msg = "";
      try { msg = JSON.parse(raw)?.error ?? ""; } catch { /* respons bukan JSON = bukan dari route API */ }
      if (!msg) {
        msg = r.status >= 500
          ? `API tidak merespons (HTTP ${r.status}). Pastikan apps/web berjalan di port 7519 dan Postgres hidup.`
          : `Gagal masuk (HTTP ${r.status}).`;
      }
      setErr(msg);
    } catch {
      setErr("Tidak bisa menghubungi API di port 7519. Jalankan: pnpm --filter @avio/web dev -p 7519");
    } finally {
      setBusy(false);
    }
  }

  const tenantName = branding?.name ?? "AVIO";
  const logoUrl    = branding?.logoUrl ?? null;

  return (
    <main style={{
      minHeight: "100vh", display: "grid", placeItems: "center", padding: "var(--space-7)",
      background: "radial-gradient(900px 420px at 78% -10%, rgba(0,85,255,.55), transparent 60%), radial-gradient(700px 320px at 10% 110%, rgba(31,138,112,.35), transparent 62%), linear-gradient(140deg, #0B1A3A 0%, #0E2360 58%, #12173A 100%)",
    }}>
      <form onSubmit={submit} style={{
        background: "var(--color-surface)", borderRadius: "var(--radius-md)", padding: "var(--space-10) var(--space-9)",
        width: 380, maxWidth: "100%", boxShadow: "0 32px 70px -30px rgba(4, 12, 32, .8)",
      }}>
        {logoUrl ? (
          <img src={logoUrl} alt={tenantName}
            style={{ display: "block", height: 52, maxWidth: 200, objectFit: "contain" }} />
        ) : (
          <img src="/logo-avio.png" alt="AVIO" width={168} height={52}
            style={{ display: "block", height: 52, width: "auto" }} />
        )}
        <p className="avio-t-sm avio-muted" style={{ margin: "var(--space-3) 0 var(--space-8)" }}>Media Intelligence Workspace</p>

        <label className="avio-t-sm" style={{ fontWeight: "var(--weight-semi)" as any }}>Email</label>
        <input className="avio-input" value={email} onChange={(e) => setEmail(e.target.value)} type="email" required
          name="email" autoComplete="email"
          placeholder="nama@perusahaan.id" style={{ width: "100%", margin: "var(--space-4) 0 var(--space-6)" }} />

        <label className="avio-t-sm" style={{ fontWeight: "var(--weight-semi)" as any }}>Password</label>
        <input className="avio-input" value={password} onChange={(e) => setPassword(e.target.value)} type="password" required
          name="password" autoComplete="current-password"
          placeholder="••••••••" style={{ width: "100%", margin: "var(--space-4) 0 var(--space-7)" }} />

        {err && (
          <div className="avio-banner" data-tone="danger" style={{ marginBottom: "var(--space-6)" }}>
            <i className="fa-solid fa-circle-exclamation avio-banner__icon" /><div>{err}</div>
          </div>
        )}

        <button className="avio-btn" data-variant="primary" disabled={busy} style={{ width: "100%", justifyContent: "center", padding: "11px 0" }}>
          {busy ? <><i className="fa-solid fa-circle-notch fa-spin" /> Memeriksa…</> : <>Masuk <i className="fa-solid fa-arrow-right" /></>}
        </button>

        <p className="avio-sub" style={{ textAlign: "center", marginTop: "var(--space-7)", marginBottom: 0 }}>
          PT Activa Digital Indonesia
        </p>
      </form>
    </main>
  );
}
